import { MemberDtoAllOfFlags } from '@web/services/crm-api/rest/crm-api.schemas';

export function getMembershipStatus(flags?: MemberDtoAllOfFlags) {
	if (flags?.isAkasseMember && flags?.isUnionMember) {
		return 'Fagforening og A-kasse';
	}

	if (flags?.isAkasseMember) {
		return 'A-kasse';
	}

	if (flags?.isUnionMember) {
		return 'Fagforening';
	}

	return null;
}
